import { render, staticRenderFns } from "./JdihSection.vue?vue&type=template&id=42e2f397&scoped=true&"
import script from "./JdihSection.vue?vue&type=script&lang=js&"
export * from "./JdihSection.vue?vue&type=script&lang=js&"
import style0 from "./JdihSection.vue?vue&type=style&index=0&id=42e2f397&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2f397",
  null
  
)

export default component.exports